/** One entry per retry attempt, in milliseconds: 5s, 15s, 1min, 5min, 15min. */
const BACKOFF_DELAYS_MS: readonly number[] = [5_000, 15_000, 60_000, 300_000, 900_000];

/** Ceiling applied past the table's last entry, reached but never crossed regardless of the attempt count. */
const MAX_BACKOFF_DELAY_MS = 1_800_000;

/**
 * Pure retry backoff: given a 1-based attempt count, returns the delay in milliseconds before the
 * next attempt. No clock, no timer, no state — this is exactly what makes a thirty-minute ceiling
 * assertable in a test without waiting thirty minutes.
 *
 * Any attempt count past the table's last entry — including a negative, fractional, or otherwise
 * absurd one — resolves to `MAX_BACKOFF_DELAY_MS`: the ceiling is reached and never exceeded,
 * whatever the attempt count.
 */
const computeBackoffDelayMs = (attemptCount: number): number => {
	const normalizedAttemptCount = Math.max(1, Math.floor(attemptCount));
	const tableIndex = normalizedAttemptCount - 1;
	const delayFromTable = BACKOFF_DELAYS_MS[tableIndex];

	if (delayFromTable === undefined) {
		return MAX_BACKOFF_DELAY_MS;
	}

	return delayFromTable;
};

export default computeBackoffDelayMs;
export { MAX_BACKOFF_DELAY_MS };
